import * as React from 'react';
import * as classNames from "classnames";
import './TrialTypesPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactSelectClass from "react-select";
import ReactTable, { Column, RowInfo } from 'react-table';
import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import { DefaultLayout, RestrictedLayout, UnrestrictedLayout, SubMenu } from "../../../components/layouts/index";
import * as TrialTypeActions from '../../../actions/trialType';
import * as PagingActions from '../../../actions/pages/pagingPage';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { ILinkProps } from "../../../components/routing/Link";
import { INavItem } from "../../../components/layouts/NavMenu/NavMenu";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import * as AuthorisationDefinitions from '../../../constants/authorisationDefinitions';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TextAreaFormInput, FormFilterInput } from '../../../components/form';
import { TrialLookupsLayout } from '../../index';
interface ITrialTypesPageProps {
  location: Location;
  history: History;

  // From state
  trialTypes: Dtos.TrialType[];
  formFilter: IFormFilter;
  formLength: number;
  loadingTrialTypes: boolean;
  loadTrialTypesSuccess: boolean;
  loadTrialTypesFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
  pageSize: number;
}
interface ITrialTypesPageActions {
  clearTrialTypes: TrialTypeActions.ITrialTypeClearActionCreator;
  loadTrialTypes: TrialTypeActions.ITrialTypeLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: TrialTypeActions.ITrialTypeFilterActionCreator;
  setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;
}
type TrialTypesPageProps = ITrialTypesPageProps & ITrialTypesPageActions;
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
  textAlign: "left",
  fontWeight: "bold",
  color: "white",
  cursor: "pointer"
};
class TrialTypesPage extends React.PureComponent<TrialTypesPageProps, any> {
  constructor(props: TrialTypesPageProps) {
    super(props);
    this.clearTrialTypes = this.clearTrialTypes.bind(this);
  }
  componentDidMount() {
    const {
      loadTrialTypes
    } = this.props;
    loadTrialTypes();
  }
  componentWillReceiveProps(nextProps: TrialTypesPageProps) {}
  componentDidUpdate(prevProps: TrialTypesPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: TrialTypesPageProps) {}
  componentWillUnmount() {
    this.clearTrialTypes();
  }
  clearTrialTypes() {
    this.props.clearTrialTypes();
  }
  showTrialTypes(): boolean {
    const {
      loadingTrialTypes,
      loadTrialTypesSuccess
    } = this.props;
    if (!loadingTrialTypes && loadTrialTypesSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrialTypes
    } = this.props;
    return <TrialLookupsLayout loading={loadingTrialTypes} permission={Dtos.Permission.TrialTypesView} data-sentry-element="TrialLookupsLayout" data-sentry-component="TrialTypesPage" data-sentry-source-file="TrialTypesPage.tsx">
            {this.renderContent()}
        </TrialLookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Trial Types</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialTypesCreate) && <Link className={"btn btn-primary"} url={"/settings/trial/trialtypes/create"}>Create</Link>}
                </div>
            </div>
            {!this.showTrialTypes() ? "Loading Trial Types" : null}
            {this.showTrialTypes() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      trialTypes,
      pageSize,
      setPageSize
    } = this.props;
    if (!trialTypes || trialTypes.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no Trial Types to view.</span>
            </div>;
    }
    const showPagination = trialTypes.length > pageSize;
    return <div className="table-wrapper mb-3">
            <ReactTable data={trialTypes} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? pageSize : trialTypes.length} pageSize={showPagination ? pageSize : trialTypes.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no Trial Types to display" resizable={false} onPageSizeChange={val => setPageSize(val)} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/trial/trialtypes/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialTypesPageProps): ITrialTypesPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    trialTypes: state.trialTypes.formFilteredData!,
    formFilter: state.trialTypes.formFilter,
    formLength: state.trialTypes.formLength,
    loadingTrialTypes: state.trialTypes.loadState && state.trialTypes.loadState.status == RequestState.Pending,
    loadTrialTypesSuccess: state.trialTypes.loadState && state.trialTypes.loadState.status == RequestState.Success,
    loadTrialTypesFailure: state.trialTypes.loadState && state.trialTypes.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles,
    pageSize: state.pagingPage.pageSize
  };
};
const mapDispatchToProps = (dispatch): ITrialTypesPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadTrialTypes: bindActionCreators(TrialTypeActions.LoadTrialType, dispatch),
    clearTrialTypes: bindActionCreators(TrialTypeActions.Clear, dispatch),
    filter: bindActionCreators(TrialTypeActions.Filter, dispatch),
    setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialTypesPage);